module.exports = __webpack_public_path__ + "img/Still-Thinking-4-mobile.33fefe84.png";